import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ThankYouPage.css';

function ThankYouPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000); // 10 seconds
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="thankyou-container">
      <div className="thankyou-content">
        <h1>We're sad to see you go! ☹️</h1>
        <p>
          Unfortunately, we cannot proceed without acceptance of Terms & Conditions, redirecting to homepage in 10 seconds.
        </p>
      </div>
    </div>
  );
}

export default ThankYouPage;
